var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"br-status",class:`br-status--${_vm.statusKey}`},[_vm._v(" "+_vm._s(_vm.getText())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }